<template>
<div class="header">
  
  <nav class="navbar navbar-expand-sm navbar-dark bg-dark"  role="navigation">
    <div class="container">
      <img src="/white-home-icon.png" alt="Home" width="30" height="30"
                style="cursor: pointer;" @click="goToHome()" title="Home"/>
      
      <div v-if="!orgName">
        <p class="ml-3" style="color:white;font-size: 20px;">SL Business Connection</p>
      </div>
      <div v-else>
        <div v-if="websiteLink">
          <a :href="websiteLink"  target="_blank" style="color:white; font-size: 20px"
                    class="font-weight-bold ml-3 mr-3">{{ orgName }}</a>
          </div>
          <div v-else>
            <p class="font-weight-bold ml-3 mr-3" style="color:white; font-size: 20px">{{ orgName }}</p>
          </div>
      </div>

      <div v-if="orgName" class="ml-auto">
        <div v-if="showPrices">
          <router-link v-bind:to="'\/cart'" class="btn btn-success" tag="button">
            Order <span class="badge badge-light">{{ numItems }} (INR {{ cartValue }})</span>
          </router-link>
        </div>
        <div v-else>
          <router-link v-bind:to="'\/cart'" class="btn btn-success" tag="button">
            Order <span class="badge badge-light">{{ numItems }}</span>
          </router-link>
        </div>

      </div>
    </div>
  </nav>

  <nav class="navbar navbar-expand-sm navbar-dark bg-dark" role="navigation">
      <div class="container">
        <div class="col-sm-12 text-center">
            <a style="color: white" v-if="isRefresh" href="#" @click="update()">Click here to update to New Version</a>
        </div>
    </div>
  </nav>

  <nav class="navbar navbar-expand-sm navbar-light bg-light" role="navigation">
      <div class="container">
        <div class="row">
          <a v-if="orgName" :href="gProfileLink" target="_blank">
            <img src="/GoogleMap2.png" alt="Map" width="30" height="30" style="cursor: pointer;" title="Google Profile"/>
          </a>

          <!-- <router-link v-if="orgName" v-bind:to="'\/gProfile'" class="font-weight-bold ml-4"  
                      @click.native="menuChange('products')"  style="color:black;">
            <img src="/GoogleMap2.png" alt="Map" width="30" height="30" style="cursor: pointer;" title="Google Profile"/>
          </router-link>  -->

          <router-link v-if="orgName && showProducts" v-bind:to="'\/products'" class="font-weight-bold ml-4" :class="productsClass" 
                      @click.native="menuChange('products')"  style="color:black;">
            Products
          </router-link> 

          <router-link v-if="orgName && showMessages" v-bind:to="'\/messages'" class="font-weight-bold ml-4" :class="messagesClass" 
                      @click.native="menuChange('messages')" style="color:black;">
            Messages
          </router-link> 

          <router-link v-if="orgName && showWholesalers" v-bind:to="'\/wholesalers'" class="font-weight-bold ml-4" :class="wholesalersClass" 
                      @click.native="menuChange('wholesalers')" style="color:black;">
            Wholesalers
          </router-link> 

        </div>
      </div>
  </nav>


</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { firebaseAuth } from '../config/firebaseConfig.js';
// import { signInWithPopup, GoogleAuthProvider } from "firebase/auth"
// import axios from "axios"

export default {
  data() {
    return {
      productsClass: 'active',
      messagesClass: 'inactive', 
      wholesalersClass: 'inactive',

      // Refresh PWA
      registration:null,
      isRefresh: false,
      refreshing: false,

      isNavOpen: false, 
      module: 'Online Store',
      // *** Temp. Get this info from DB
      orgUrl: "https://ketco-irons.com"

    }
  },

  computed: {
    ...mapGetters(['isLoggedIn', 'currentUser', 'cartValue', 'cartItemList', 'orgId', 'orgName',
                   'websiteLink', 'gProfileLink', 'showProducts', 'showMessages', 'showWholesalers', 'showPrices'
                  ]),

    numItems() {
      return this.cartItemList.reduce((total, item) => {
        total += item.quantity;
        return total
      }, 0);
    },
    userEmail() {
      return this.isLoggedIn ? this.currentUser.email : ''
    }
  },

  // Refresh PWA
  created() {
      document.addEventListener(
          'serviceWorkerUpdateEvent', this.appUpdateUI, { once: true }
      )
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // We'll also need to add 'refreshing' to our data originally set to false.
        if (this.refreshing) return
        this.refreshing = true
        // Here the actual reload of the page occurs
        window.location.reload()
      })

  },
  
  mounted(){
  },

  methods: {
    ...mapActions(['authStatusChange', 'addMessage']),

    menuChange(menu){
      if (menu=='products'){
        this.productsClass = 'active'
        this.messagesClass = 'inactive'
        this.wholesalersClass = 'inactive'
      }
      else if (menu=='messages'){
        this.productsClass = 'inactive'
        this.messagesClass = 'active'
        this.wholesalersClass = 'inactive'
      }
      else if (menu=='wholesalers'){
        this.productsClass = 'inactive'
        this.messagesClass = 'inactive'
        this.wholesalersClass = 'active'
      }
    },

    goToHome(){
      this.productsClass = 'active'
      this.messagesClass = 'inactive'
      this.wholesalersClass = 'inactive'
      this.$router.push('/home')
    },


    // async userGoogleLogin(){
    //   var self = this

    //   const provider = new GoogleAuthProvider()
    //   provider.setCustomParameters({
    //       prompt: 'select_account'
    //   })

    //   await signInWithPopup(firebaseAuth, provider)
    //   this.authStatusChange()
    //   if (self.currentUser == null){
    //     return
    //   }

    //   // Send userid and notification token to backend for update
    //   const notificationToken = await self.getNotificationToken()
    //   const authToken = await self.currentUser.getIdToken()
    //   let jsonData = {'notificationToken': notificationToken}
      
    //   axios({
    //     method: 'POST',
    //     baseURL: process.env.VUE_APP_ROOT_API,
    //     url: '/UserSignIn/',
    //     data: jsonData,
    //     headers: {
    //       'Authorization': 'Bearer ' + authToken,
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .then(function (response) {
    //     if (response.data.err != ''){
    //       self.addMessage({messageClass: 'warning', message: response.data.err,})
    //     }
    //   })
    //   .catch(function (error) {
    //     self.addMessage({messageClass: 'danger', message: String(error),})
    //   })
    // },

    logOut () {
      var self = this
      //firebase.auth().signOut()
      firebaseAuth.signOut()
        .then(function () {
          self.authStatusChange()
        })
        .catch(function (error) {
          self.addMessage({messageClass: 'error', message: String(error.message),})
        })
    }, 

    toggleNavbar() {
      this.isNavOpen = !this.isNavOpen
    },

    // ***** Refresh PWA
    appUpdateUI:function (e){
      this.registration = e.detail;
      this.isRefresh = true;
      console.log('appUpdateUI')
      console.log(this.isRefresh)
    },

    update(){
      this.isRefresh = false;
      console.log('update')
      console.log(this.isRefresh)
      if (this.registration || this.registration.waiting) {
        this.registration.waiting.postMessage({type:'SKIP_WAITING'});
      }
    },
    // ***** Refresh PWA

  }
}
</script>


<style scoped lange="sass">

.header {
  position:fixed; /* fixing the position takes it out of html flow - knows
                   nothing about where to locate itself except by browser
                   coordinates */
  z-index:200;  /* high z index so other content scrolls underneath */
  left: 50%;
  transform: translate(-50%, 0);
  width:100vw;      /* take up the full browser width */
}

.navbar-btn a {
  color: white;
}

.li-pointer {
  cursor: pointer;
}

.li-pointer:hover {
  cursor: pointer;
}

.active{
  text-decoration: underline;
}
.inactive{
  text-decoration: none;
}
</style>
